<!--
  The Firuza loader (DESIGN.md §5.8): an eight-point girih star outline in the
  accent, turning slowly. Same props as the old square spinner.
-->
<script lang="ts">
  export let size: 'small' | 'medium' | 'large' = 'medium'
</script>

<div class="girih-loader size-{size}" role="progressbar" aria-busy="true">
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round">
    <polygon
      points="12.00,2.00 9.07,4.93 4.93,4.93 4.93,9.07 2.00,12.00 4.93,14.93 4.93,19.07 9.07,19.07 12.00,22.00 14.93,19.07 19.07,19.07 19.07,14.93 22.00,12.00 19.07,9.07 19.07,4.93 14.93,4.93"
    />
  </svg>
</div>

<style lang="scss">
  .girih-loader {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--fz-accent-text);

    svg {
      width: 100%;
      height: 100%;
      animation: girihSpin 2.4s linear infinite;
    }
    &.size-small {
      width: 1.5rem;
      height: 1.5rem;
    }
    &.size-medium {
      width: 2rem;
      height: 2rem;
    }
    &.size-large {
      width: 3rem;
      height: 3rem;
    }
  }

  @keyframes girihSpin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .girih-loader svg {
      animation: none;
    }
  }
</style>
